import { useAuthStore } from '@/lib/auth';

import { LANGUAGE_CONFIG, type SupportedLanguage } from '../config/languages';
import { LanguageDetection } from '../core/languageDetection';

type LanguageDetectionResult = {
  detectedLanguage: SupportedLanguage;
};

/**
 * 言語プロバイダー型定義
 */
export interface DetectedLanguageProvider {
  sessionLocale?: SupportedLanguage | null;
  clientLocale?: SupportedLanguage | null;
}

/**
 * 言語設定を検出するカスタムフック
 *
 * README.md記載の優先順位に従って言語を決定:
 * 1. バックエンドサーバのセッションロケール
 * 2. AuthStoreの設定（ユーザーが明示的に選択した言語）
 * 3. ブラウザの言語設定
 *
 * @param languageProvider - 言語情報プロバイダー（sessionLocaleの注入用）
 */
export const useDetectedLanguage = (
  languageProvider?: DetectedLanguageProvider,
): LanguageDetectionResult => {
  const authStore = useAuthStore();

  return LanguageDetection.createDetectionResult({
    sessionLocale:
      languageProvider?.sessionLocale ?? authStore.session?.locale ?? null,
    clientLocale: languageProvider?.clientLocale ?? authStore.locale ?? null,
    browserLanguage: navigator.language ?? LANGUAGE_CONFIG['en-US'].code,
    config: LANGUAGE_CONFIG,
  });
};
